<template>
  <div class="card mb-3">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold text-primary">Profile Info 2</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-marital_status" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Marital Status</label>
            <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="marital_status" id="form-marital_status" v-model="data.marital_status" >
              <option value="" selected="" disabled="">Pilih Status</option>
              <option :value="data1.id" v-for="(data1,index) in marital_status_arr" :key="index">{{ data1.name }}</option>
            </select>
          </div>
        </div>
        <!-- <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-tribes" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Tribes</label>
            <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="tribes" id="form-tribes" v-model="data.tribes" >
              <option value="" selected="" disabled="">Pilih Tribes</option>
              <option v-for="(data1,index) in tribes_arr" :key="index" :value="data1.id">{{ data1.name }}</option>
            </select>
          </div>
        </div> -->
        <div class="form-group col-12 mb-2" v-if="data.type.name == 'Helper'">
          <div class="row px-3">
            <label for="#form-blood_type" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Blood Type</label>
            <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="blood_type" id="form-blood_type" v-model="data.blood_type" >
              <option value="" selected="" disabled="">Pilih Golongan Darah</option>
              <option v-for="(data1,index) in blood_type_arr" :key="index" :value="data1.id">{{ data1.name }}</option>
            </select>
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-religion" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Religion</label>
            <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="religion" id="form-religion" v-model="data.religion" >
              <option value="" selected="" disabled="">Pilih Religion</option>
              <option v-for="(data1,index) in religion_arr" :key="index" :value="data1.id">{{ data1.name }}</option>
            </select>
          </div>
        </div>
        <div class="form-group col-12 mb-2" v-if="data.type.name == 'Helper'">
          <div class="row px-3">
            <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Pendidikan</label>
            <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="education" id="form-education" v-model="data.education" >
              <option value="" selected="" disabled="">Pilih Pendidikan Terakhir</option>
              <option v-for="(data1,index) in education_arr" :key="index" :value="data1.id">{{ data1.name }}</option>
            </select>
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Punya Anak</label>
            <div v-show="this.$route.query.id != null ? is_allow_edit : true">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="have_children" v-model="data.have_children" id="have_children_yes" :value="1"/>
                <label class="form-check-label" for="have_children_yes">
                  Ya
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="have_children" v-model="data.have_children" id="have_children_no" :value="0"/>
                <label class="form-check-label" for="have_children_no">
                  Tidak
                </label>
              </div>
            </div>
            <div v-show="this.$route.query.id != null ? !is_allow_edit : false">
              <p class="m-0">{{ data.have_children == 1 ? 'Ya' : 'Tidak' }}</p>
            </div>
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-education" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Lokasi saat ini</label>
            <select class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" id="form-education" v-model="data.city" >
              <option value="" selected="" disabled="">Pilih Kota</option>
              <option v-for="(data1,index) in city_arr" :key="index" :value="data1.id">{{ data1.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data','is_allow_edit',],
  data(){
    return{
      marital_status_arr: [],
      tribes_arr: [],
      blood_type_arr: [],
      religion_arr: [],
      education_arr: [],
      city_arr: [],
    }
  },
  created(){
    this.get_marital_status_data()
    this.get_tribes_data()
    this.get_blood_type_data()
    this.get_religion_data()
    this.get_education_data()
    this.get_city_data()
  },
  methods:{
    async get_marital_status_data(){
      var response = await axios.get(base_url+'/marital-status/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.marital_status_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_tribes_data(){
      var response = await axios.get(base_url+'/tribe/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.tribes_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_blood_type_data(){
      var response = await axios.get(base_url+'/blood-type/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.blood_type_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_religion_data(){
      var response = await axios.get(base_url+'/religion/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.religion_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_education_data(){
      var response = await axios.get(base_url+'/education/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.education_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_city_data(){
      var response = await axios.get(base_url+'/city/all')

      var response_data = response.data

      if(response_data.status == "success"){
        this.city_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
  }
}
</script>
